import { useContext } from "react";
import { NoteContext } from "../context/NoteContext";
import Notes from "../models/Notes";

export default function useNotes(): Notes|null {
    const [notes] = useContext(NoteContext) ?? [null];

    return notes;
}